import { render } from "./AddPrice.vue?vue&type=template&id=12e7b69c&scoped=true"
import script from "./AddPrice.vue?vue&type=script&lang=js"
export * from "./AddPrice.vue?vue&type=script&lang=js"

import "./../../../assets/styles/admin/pricing/addPrice.scss?vue&type=style&index=0&id=12e7b69c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e7b69c"]])

export default __exports__